module.exports = __webpack_public_path__ + "static/media/Plan.361c17e5.png";